import axios from "axios";

class ApiService {
    constructor(baseURL) {
        this.api = axios.create({
            baseURL: baseURL,
            timeout: 10000,
        });

        this.api.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("tokenA");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                    config.headers['Content-Type'] = "application/x-www-form-urlencoded;charset=UTF-8"
                }
                return config;
            },
            (error) => {
                console.error("[Request Error]:", error.message);
                return Promise.reject(error);
            }
        );

        this.api.interceptors.response.use(
            (response) => response,
            (error) => {
                console.error("[Response Error]:", error.response?.data || error.message);
                return Promise.reject(error);
            }
        );
    }

    get(endpoint, params = {}) {
        return this.api.get(endpoint, { params });
    }

    post(endpoint, data = {}, config = {}) {
        return this.api.post(endpoint, data, config);
    }

    delete(endpoint, config = {}) {
        return this.api.delete(endpoint, config);
    }

    put(endpoint, data = {}, config = {}) {
        return this.api.put(endpoint, data, config);
    }
}

export default ApiService; 
